/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteHistoryForTransferredPatient$Params {
  patientId: string;
  fromBpGuid: string;
}

export function deleteHistoryForTransferredPatient(http: HttpClient, rootUrl: string, params: DeleteHistoryForTransferredPatient$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteHistoryForTransferredPatient.PATH, 'delete');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.path('fromBpGuid', params.fromBpGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteHistoryForTransferredPatient.PATH = '/recent-history/clear/transferred-patient/{patientId}/{fromBpGuid}';
